import type { Components } from "react-markdown";

import { colorsPalettes } from "@similarweb/styles";
import { Text, Box } from "@similarweb/ui-components/foundations";

import { StyledCompanyLogo } from "../components/ChatMessage/styles";
import {
    StyledHr,
    StyledLi,
    StyledTable,
    StyledTd,
    StyledText,
    StyledTh,
    StyledUl,
} from "../components/markdown-components";

export const getBaseMarkdownComponents: (props: Record<string, unknown>) => Components = (props) => ({
    h1: ({ children }) => (
        <Text
            fontVariant="h3"
            display="block"
            color={colorsPalettes.carbon[500]}
            margin="0 0 24px"
            className="meeting-agent-section-title"
        >
            {children}
        </Text>
    ),
    h2: ({ children }) => (
        <Text
            fontVariant="h4"
            display="block"
            color={colorsPalettes.carbon[500]}
            margin="0 0 16px"
            className="meeting-agent-section-title"
        >
            {children}
        </Text>
    ),
    h3: ({ children }) => (
        <Text
            fontVariant="h5"
            display="block"
            color={colorsPalettes.carbon[500]}
            margin="0 0 8px"
            className="meeting-agent-section-title"
        >
            {children}
        </Text>
    ),
    h4: ({ children }) => (
        <Text
            fontVariant="input2Bold"
            display="block"
            margin="0 0 4px"
            color={colorsPalettes.carbon[500]}
        >
            {children}
        </Text>
    ),
    h5: ({ children }) => (
        <Text
            fontVariant="h5"
            display="block"
            color={colorsPalettes.carbon[500]}
            margin="0 0 8px"
        >
            {children}
        </Text>
    ),
    p: ({ children }) => (
        <StyledText
            fontVariant="body2"
            display="block"
            margin="0 0 24px"
            color={colorsPalettes.carbon[400]}
        >
            {children}
        </StyledText>
    ),
    table: ({ children }) => <StyledTable>{children}</StyledTable>,
    th: ({ children }) => <StyledTh>{children}</StyledTh>,
    td: ({ children }) => <StyledTd>{children}</StyledTd>,
    ul: ({ children }) => <StyledUl>{children}</StyledUl>,
    li: ({ children }) => <StyledLi>{children}</StyledLi>,
    hr: () => <StyledHr />,
    br: () => <Box margin="0 0 4px" />,
    img: ({ alt, ...rest }) => {
        const { companyLogoSrc } = props as Record<"companyLogoSrc", string>;

        if (alt === "company_logo") {
            return <StyledCompanyLogo src={companyLogoSrc} />;
        }

        return <img {...rest} />;
    },
});
